
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thanh-toan",
      function () {
        return require("private-next-pages/thanh-toan/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thanh-toan"])
      });
    }
  